import {Injectable} from '@angular/core';
import {SpatialSequenceService} from '../../../common/service/spatial-sequence.service';
import {SpatialUtilService} from '../spatial-util.service';
import {FeaturesApplyInsertService} from '../features-apply-insert.service';
import {tap} from 'rxjs';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class PointService {
    title = 'PointService';

    constructor(
        private featuresApplyInsertService: FeaturesApplyInsertService,
        private spatialSequenceService: SpatialSequenceService,
        private spatialUtilService: SpatialUtilService
    ) {}

    create(feature: any) {
        console.debug(`${this.title} create`);

        feature.attributes.id = this.spatialSequenceService.getPointSequence(1)[0];

        const layer =
            feature.attributes.type < 6 || feature.attributes.type == 100
                ? this.spatialUtilService.getControlPointMapLayer()
                : this.spatialUtilService.getPointMapLayer();

        return this.featuresApplyInsertService
            .insertFeaturesByType(layer, [feature])
            .pipe(tap(() => console.debug('Point has been successfully created!')));
    }
}
